import { Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A0E1A] text-white py-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2 text-sm">
            <span>© {currentYear} Devansh Gupta. All rights reserved.</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-white/70">
            <span>Made with</span>
            <Heart className="text-[#9A7B4F]" size={16} fill="#9A7B4F" />
            <span>in Milan</span>
          </div>
        </div>
        <div className="text-center mt-4 text-xs text-white/50">
          <p>Finance Student | Business Consultant | Social Impact Leader</p>
          <p className="mt-1">Università Bocconi, Milan | Kolkata, India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;